import uniAdminApi from "./api";

const facultyService = {
  getFaculties: async (page = 0, size = 10, search = "", campusId = null, status = true) => {
    const params = { page, size };
    if (search) params.search = search;
    if (campusId) params.campusId = campusId;
    if (status !== null && status !== undefined) params.status = status;
    const res = await uniAdminApi.get("/university-admin/faculties", { params });
    return res.data;
  },

  createFaculty: async (data) => {
    const res = await uniAdminApi.post("/university-admin/faculties", data);
    return res.data;
  },

  updateFaculty: async (id, data) => {
    const res = await uniAdminApi.put(`/university-admin/faculties/${id}`, data);
    return res.data;
  },

  deleteFaculty: async (id) => {
    const res = await uniAdminApi.delete(`/university-admin/faculties/${id}`);
    return res.data;
  },
};

export default facultyService;
